import { dark, light } from '@pancakeswap-libs/uikit'

// Libera Investments brand palette (extracted from liberainvestments.com):
// navy/charcoal surfaces, blue buttons, cyan link/text accent, off-white text.
// `primary` drives button backgrounds paired with white text (uikit hardcodes
// white button text, not theme-driven) - liberainvestments.com's actual button
// blue (#1653A1) passes WCAG AA (7.5:1); their link cyan (#04E2FF) does not
// (1.6:1) so it's used as `secondary`/text accent instead, never as a button fill.
const liberaDarkColors = {
  ...dark.colors,
  primary: '#1653A1',
  primaryBright: '#2E89FF',
  primaryDark: '#0D2E5C',
  secondary: '#04E2FF',
  background: '#0B0E14',
  backgroundDisabled: '#1B2230',
  contrast: '#FFFFFF',
  invertedContrast: '#0B0E14',
  input: '#151A24',
  inputSecondary: '#1E2430',
  tertiary: '#151A24',
  text: '#F4F3EE',
  textDisabled: '#5B6472',
  textSubtle: '#85A1BB',
  borderColor: '#232B38',
  card: '#12161F',
  gradients: { bubblegum: 'linear-gradient(139.73deg, #0B2A33 0%, #0B1730 100%)' },
}

const liberaLightColors = {
  ...light.colors,
  primary: '#1653A1',
  primaryBright: '#2E89FF',
  primaryDark: '#0D2E5C',
  secondary: '#0089A1',
  background: '#F5F7FA',
  backgroundDisabled: '#E4E8EC',
  contrast: '#0B0E14',
  invertedContrast: '#FFFFFF',
  input: '#EEF1F4',
  inputSecondary: '#DCE2E8',
  tertiary: '#EEF1F4',
  text: '#0B0E14',
  textDisabled: '#A9B2BC',
  textSubtle: '#4C5A6B',
  borderColor: '#DCE2E8',
  card: '#FFFFFF',
  gradients: { bubblegum: 'linear-gradient(139.73deg, #E6FBFF 0%, #EAF1FF 100%)' },
}

export const liberaDark = {
  ...dark,
  colors: liberaDarkColors,
  card: {
    ...dark.card,
    background: liberaDarkColors.card,
    cardHeaderBackground: 'linear-gradient(111.68deg, #101522 0%, #0E1A22 100%)',
    dropShadow: 'drop-shadow(0px 4px 24px rgba(4, 226, 255, 0.08)) drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.4))',
  },
  nav: { ...dark.nav, background: liberaDarkColors.card, hover: '#1A2130' },
  modal: { ...dark.modal, background: liberaDarkColors.card },
  toggle: { ...dark.toggle, handleBackground: liberaDarkColors.card },
  radio: { ...dark.radio, handleBackground: liberaDarkColors.card },
}

export const liberaLight = {
  ...light,
  colors: liberaLightColors,
  card: {
    ...light.card,
    background: liberaLightColors.card,
    cardHeaderBackground: 'linear-gradient(111.68deg, #F0FBFF 0%, #EEF4FF 100%)',
    dropShadow: 'drop-shadow(0px 4px 24px rgba(22, 83, 161, 0.08)) drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.08))',
  },
  nav: { ...light.nav, background: liberaLightColors.card, hover: '#EEF1F4' },
  modal: { ...light.modal, background: liberaLightColors.card },
  toggle: { ...light.toggle, handleBackground: liberaLightColors.card },
  radio: { ...light.radio, handleBackground: liberaLightColors.card },
}
